import {
  setMasterDataSuccess,
  setMasterDataFailure,
  setPartialMasterDataFailure,
  setCountriesData,
  setCountriesLoading,
  setCountriesError,
  setDivisionsData,
  setDivisionsLoading,
  setDivisionsError,
  setZonesData,
  setZonesLoading,
  setZonesError,
  setStatesData,
  setStatesLoading,
  setStatesError,
  setCarriersData,
  setCarriersLoading,
  setCarriersError,
  setServicesData,
  setServicesLoading,
  setServicesError,
  setTransportsData,
  setTransportsLoading,
  setTransportsError,
  setEquipmentsData,
  setEquipmentsLoading,
  setEquipmentsError,
  setTariffEquipmentMappingData,
  setTariffEquipmentMappingLoading,
  setTariffEquipmentMappingError,
  setChargesData,
  setChargesLoading,
  setChargesError,
  setTariffIdsData,
  setTariffIdLoading,
  setTariffIdError,
  setZoneShortDescData,
  setZoneShortDescLoading,
  setZoneShortDescError,
  setZoneLongDescData,
  setZoneLongDescLoading,
  setZoneLongDescError,
} from "../reducers/drmLiveLoadMasterDataSlice";
import { put, call, takeLatest, all, cancelled } from "redux-saga/effects";
import { fetchDrmMasterData } from "../../service/fetchDrmMasterData";
import { getCountriesWithUSFirst } from "../../helpers";

function* allSettled(effects) {
  const results = yield all(
    effects.map(function* (effect) {
      try {
        const result = yield effect;
        return { status: "fulfilled", value: result };
      } catch (error) {
        return { status: "rejected", reason: error };
      }
    })
  );
  return results;
}

// Map masterDataType → slice actions
const masterDataConfig = {
  countries: {
    fetchKey: "drmCountryData",
    setData: setCountriesData,
    setLoading: setCountriesLoading,
    setError: setCountriesError,
    transform: getCountriesWithUSFirst,
  },
  divisions: {
    fetchKey: "drmDivisionData",
    setData: setDivisionsData,
    setLoading: setDivisionsLoading,
    setError: setDivisionsError,
  },
  zones: {
    fetchKey: "drmZoneData",
    setData: setZonesData,
    setLoading: setZonesLoading,
    setError: setZonesError,
  },
  states: {
    fetchKey: "drmStateData",
    setData: setStatesData,
    setLoading: setStatesLoading,
    setError: setStatesError,
  },
  carriers: {
    fetchKey: "drmCarrierData",
    setData: setCarriersData,
    setLoading: setCarriersLoading,
    setError: setCarriersError,
  },
  services: {
    fetchKey: "drmServiceData",
    setData: setServicesData,
    setLoading: setServicesLoading,
    setError: setServicesError,
  },
  transports: {
    fetchKey: "drmTransportData",
    setData: setTransportsData,
    setLoading: setTransportsLoading,
    setError: setTransportsError,
  },
  equipments: {
    fetchKey: "drmEquipmentData",
    setData: setEquipmentsData,
    setLoading: setEquipmentsLoading,
    setError: setEquipmentsError,
  },
  tariffEquipmentMapping: {
    fetchKey: "drmTariffEquipMappingData",
    setData: setTariffEquipmentMappingData, 
    setLoading: setTariffEquipmentMappingLoading,
    setError: setTariffEquipmentMappingError,
  },  
  charges: {
    fetchKey: "drmChargesData",
    setData: setChargesData,
    setLoading: setChargesLoading,
    setError: setChargesError,
  },
   tariffIds: {
    fetchKey: "drmTariffIdsData",
    setData: setTariffIdsData,
    setLoading: setTariffIdLoading,
    setError: setTariffIdError,
  },
  zoneShortDesc: {
    fetchKey: "drmZoneShortDescData",
    setData: setZoneShortDescData,
    setLoading: setZoneShortDescLoading,
    setError: setZoneShortDescError,
  },
  zoneLongDesc: {
    fetchKey: "drmZoneLongDescData",
    setData: setZoneLongDescData,
    setLoading: setZoneLongDescLoading,
    setError: setZoneLongDescError,
  },
};


export function* workerFetchMasterData(action) {
  const controller = new AbortController();
  const { body = [], masterDataType = "all", onPage = 1 } = action.payload || {};

  try {
    const errors = [];
    const masterData = {};

    if (masterDataType === "all") {
      const apiCalls = Object.entries(masterDataConfig)
        .filter(([key]) => key !== "tariffIds" && key !== "tariffEquipmentMapping")
        .map(([key, cfg]) => ({
          key,
          call: call(fetchDrmMasterData, [cfg.fetchKey, body, onPage, controller]),
        }));

      const results = yield* allSettled(apiCalls.map((api) => api.call));

      apiCalls.forEach(({ key }, index) => {
        const result = results[index];
        const cfg = masterDataConfig[key];

        if (result.status === "fulfilled") {
          let details = result.value?.details || {};
          if (cfg.transform) {
             details = {
                ...details,
                data: cfg.transform(details.data || [])
            };
          }
          masterData[key] = details;
        } else {
          masterData[key] = [];
          errors.push({
            endpoint: key,
            message: result.reason?.message || result.reason?.toString() || `Failed to fetch ${key}`
          });
          console.error(`Error fetching ${key}:`, result.reason);
        }
      });

      yield put(setMasterDataSuccess({ data: masterData }));
      
      if (errors.length > 0) {
        yield put(setPartialMasterDataFailure({
          errors,
          affectedEndpoints: errors.map(e => e.endpoint)
        }));
      }
    } else if (masterDataConfig[masterDataType]) {
     
      const cfg = masterDataConfig[masterDataType];
      try {
        yield put(cfg.setLoading(true));
        const result = yield call(fetchDrmMasterData, [cfg.fetchKey, body, onPage, controller]);
        let details = result?.details || {};
        if (cfg.transform) {
            details = {
                ...details,
                data: cfg.transform(details.data || [])
            };
        }
        yield put(cfg.setData({ details }));
      } catch (error) {
        console.error(`Error fetching ${masterDataType}:`, error);
        yield put(cfg.setError(error?.message || error.toString()));
      }
    } else {
      console.warn(`Unknown masterDataType: ${masterDataType}`);
      yield put(setMasterDataFailure({
        message: `Unknown masterDataType: ${masterDataType}`,
        apiCallType: masterDataType
      }));
    }
  } catch (error) {
    console.error("Unexpected error in master data saga:", error);
    yield put(setMasterDataFailure({
      message: error?.message || error.toString(),
      apiCallType: masterDataType
    }));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmLiveMasterDataSaga() {
  yield takeLatest('masterData/startMasterDataFetching', workerFetchMasterData);
}

export default drmLiveMasterDataSaga;